import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const M1_HUB_PAGES = gate('SSM:PricingPageV2:M1HubPages');
export const M2_BUNDLE_PAGES = gate('SSM:PricingPageV2:M2BundlePages');
export const M3_SMART_CRM_PAGES = gate('SSM:PricingPageV2:M3SmartCRMPages');
export const HUBSPOT_CREDITS_PAGE_V2 = gate('SSM:PricingPageV2:HubSpotCreditsV2');
export const PPFE_PRICING_PAGE_V2_ADD_ONS = gate('PPFE:PricingPageV2:AddOns');
export const PPFE_INTERSTITIAL_V2_ROUTING = gate('PPFE:InterstitialV2Routing');
export const TRI_TEMPORARY_DISCOUNT = gate('TRI::TemporaryDiscount');